var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconDownload = function SvgNnIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "210.7 192 605.1 640"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 832 210.7 530.7l45.3-45.2 256 256 256-256 45.3 45.3z",
    className: "nn-icon-download_svg__s0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M544 832h-64V192h64z",
    className: "nn-icon-download_svg__s0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m210.8 832-.1-64 605.1-.1v64z",
    className: "nn-icon-download_svg__s0"
  })));
};
export default SvgNnIconDownload;